import { render, staticRenderFns } from "./ProductPagination.vue?vue&type=template&id=d6713e66&"
import script from "./ProductPagination.vue?vue&type=script&lang=js&"
export * from "./ProductPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports